import { Button, Image, Result, Spin } from "antd";
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import Logo from "../../assets/images/logo_WasteNoFood_header.gif";
import { API } from "../../config/api";
import { PostAPIRequest } from "../../services/api";
function VerifyEmail({ history }) {
  const EmailStatus = {
    Verifying: "Verifying",
    Failed: "Failed",
    Success: "Success",
  };

  const [emailStatus, setEmailStatus] = useState(EmailStatus.Verifying);

  useEffect(() => {
    const { token } = queryString.parse(window.location.search);

    // remove token from url to prevent http referer leakage
    //history.replace(window.location.pathname);
    PostAPIRequest({
      url: API.verifyEmail,
      data: {
        token: token,
      },
    })
      .then((response) => {
        console.log("Request Successful!", response);
        if (response.status === "success") {
          //alert("You have successfully verified your email, you can login now");
          //window.location.replace("");
          setEmailStatus(EmailStatus.Success);
        } else {
          alert(response.message);
          setEmailStatus(EmailStatus.Failed);
        }
      })
      .catch((error) => {
        console.error("Request Failed:", error);
        setEmailStatus(EmailStatus.Failed);
      });
  }, []);

  function getBody() {
    switch (emailStatus) {
      case EmailStatus.Verifying:
        return (
          <>
            <Result title="Verifing... Please Wait.." />
            <Spin size="large" />
          </>
        );
      case EmailStatus.Success:
        return (
          <Result
            status="success"
            title="Thank You!"
            subTitle="You have successfully verified your email, you can login now!"
            extra={[
              <Button
                type="primary"
                key="console"
                onClick={() => {
                  if (isMobile) {
                    window.open("wastenofood://com.app.wnf");
                  } else {
                    window.open("https://webapp.wastenofood.org");
                  }
                }}
              >
                Continue
              </Button>,
            ]}
          />
        );
      case EmailStatus.Failed:
        return (
          <Result
            status="500"
            title="Verification Failed!"
            subTitle="Token expired, Please contact your administrator"
          />
        );
    }
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Image style={{ marginTop: 20, marginBottom: 30 }} src={Logo} />
      <div
        style={{
          alignSelf: "stretch",
          marginTop: 40,
          marginBottom: 30,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {getBody()}
      </div>
    </div>
  );
}

export default VerifyEmail;
